import { Component } from 'react'
import Head from 'next/head'

import AppBar from 'Components/AppBar'
import Breadcrumb from 'Components/Breadcrumb'
import CustomerServiceBox from 'Components/CustomerServiceBox'
import Footer from 'Components/Footer'
import Shops from 'Components/Shops'
import StoresMap from 'Components/Stores/StoresMap'
import StoresVideoContainer from 'Components/Stores/StoresVideoContainer'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'
import { goBack } from 'Utils/helpers/routerHelper'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Components/Stores/StoresPage.scss'
import plph from 'Components/ProductListPage/components/ProductListPageHeader/ProductListPageHeader.scss'
import { SVGArrowBack } from 'Components/SVGCollection'
import { formatBreadcrumbForGtm } from 'Components/Breadcrumb/Breadcrumb';

class StoresPage extends Component {
  render() {
    const breadcrumbData = [
      {
        href: '/',
        title: 'Főoldal',
        gtmName: 'Home'
      },
      {
        href: '/stores',
        title: 'Üzleteink',
        gtmName: 'Stores'
      }
    ]

    return (
      <div>
        <Head>
          <title>Üzleteink</title>
        </Head>

        <AppBar
          viewType={AppBarViewType.SubPage}
          pageTitle={"Üzleteink"}
          pageType="Home"
          breadcrumb={formatBreadcrumbForGtm(breadcrumbData)}
        />

        <div className={cn(cg.gridContainer, cl.storesContainer)}>
          <div className={cn(cg.showForMedium, cl.breadcrumbContainer)}>
            <Breadcrumb data={breadcrumbData} />
          </div>

          <div className={cn(cg.gridX, plph.productListPage__header, cg.showForLarge)}>
            <div className={cn(cg.cell, cg.shrink)}>
                <a className={plph.linkBack} onClick={goBack}>
                    <span className={cg.showForSr}>
                        Vissza
                    </span>

                    <span aria-hidden="true">
                        <SVGArrowBack width="32" height="32" />
                    </span>
                </a>
            </div>
            <div className={cn(cg.cell, cg.auto)}>
                <h1 className={plph.h1}>
                  Üzleteink
                </h1>
            </div>
        </div>

          <StoresMap />

          <div className={cn(cg.gridX, cg.gridMarginX, cl.storesInfoContainer, cl.storesInfoContainer__gridMarginX)}>
            <div className={cn(cg.cell, cg.medium5, cl.storesInfoContainer__cell, cl.storesInfoContainer__medium5, cg.showForMedium)}>
              <CustomerServiceBox />
            </div>

            <div className={cn(cg.cell, cg.medium7, cl.storesInfoContainer__cell, cl.storesInfoContainer__medium7)}>
              <Shops />
            </div>
          </div>

          <div className={cn(cg.gridX, cg.gridMarginX, cl.storesVideoContainers, cl.storesVideoContainers__gridMarginX)}>
            <div className={cn(cg.cell, cg.medium6, cl.storesVideoContainers__cell, cl.storesVideoContainers__medium6)}>
              <StoresVideoContainer>
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/fBiN52X7AmU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </StoresVideoContainer>
            </div>
          </div>
        </div>

        {/* TODO: gallery */}

        <Footer />
      </div>
    )
  }
}

export default StoresPage
